import SubHeaderComponent from "./Header/SubHeader";

export default function Header({ loggedInUser }) {
  return (
    <div className="header">
      <SubHeaderComponent loggedInUser={loggedInUser} />
    </div>
  );
}
